import { make } from 'vuex-pathify'
import Auth from '@/api/auth'
import Storage from '@utils/storage'
import Request from '@utils/request'

const authTokenName = 'LOGIN_INFO'

const token = Storage.get(authTokenName)

const state = {
  token,
  loggedInStatus: !!token
}

const mutations = make.mutations(state)

const actions = {
  ...make.actions(state),

  async login({ commit }, { username, password }) {
    try {
      const res = await Auth.login({ username, password })
      commit('SET_TOKEN', res.data.auth_token.access_token)
      commit('SET_LOGGED_IN_STATUS', true)
      Storage.set(authTokenName, res.data.auth_token.access_token)
      Request.setAuthHeader()
      return res
    } catch (e) {
      return false
    }
  },

  async logout({ commit }) {
    Request.setCatchError(401, false)

    try {
      await Auth.logout()
    } catch (e) {
      console.log('e', e)
    }
    Storage.remove(authTokenName)
    commit('SET_TOKEN', null)
    commit('SET_LOGGED_IN_STATUS', false)
    location.reload()
  },

  async forgotPassword({ commit }, { email }) {
    try {
      await Auth.forgotPassword({ email })
    } catch (e) {
      console.log('e', e)
    }
  },

  async resetPassword({ commit }, payload) {
    try {
      await Auth.resetPassword(payload)
    } catch (e) {
      console.log('e', e)
    }
  },

  async limitAccess() {
    location.replace('/403')
  }
}

const getters = make.getters(state)

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
